<template>
  <v-app>
    <v-content>
      <v-container fluid>
        <v-layout style="margin-top: 5%">
          <v-flex xs12 sm12 md4 lg4 offset-md4 offset-lg4>
            <img style="padding-left: 25%; padding-right: 25%" src="@/assets/Back/images/ol-pejeta-logo.svg" width="100%" alt="logo">
            <br>
            <br>
            <v-card flat>
              <v-container>
                <v-form lazy-validation @submit.prevent="doReset()">
                  <v-text-field
                    v-model="login.password"
                    label="Password"
                    required
                    type="password"
                  ></v-text-field>
                  <v-text-field
                    v-model="login.new_password"
                    label="Confirm Password"
                    required
                    type="password"
                  ></v-text-field>
                  <v-btn :depressed="true" type="submit" color="primary" :loading="$loadingTrue">
                    Reset
                  </v-btn>
                </v-form>
              </v-container>
            </v-card>
            <br>
            <br>
            <v-layout>
              <!--<v-flex xs2 sm2 md2 lg2 offset-xs1 offset-sm1 offset-md1 offset-lg1>-->
                <!--<img style="padding: 5%" src="@/assets/Both/Logos/Boran%20Beef/Horizontal/Boran%20Beef%20Logo_Horizontal.png" width="100%" alt="logo">-->
              <!--</v-flex>-->
              <!--<v-flex xs2 sm2 md2 lg2>-->
                <!--<img style="padding: 5%" src="@/assets/Both/Logos/Morani%20Center/Horizontal/MoraniCenterLogo_horizontal.png" width="100%" alt="logo">-->
              <!--</v-flex>-->
              <!--<v-flex xs2 sm2 md2 lg2>-->
                <!--<img style="padding: 5%" src="@/assets/Both/Logos/Sweewaters%20Chimpanzee%20Sanctuary/Horizontal/Sweewaters%20Sanctuary%20Logo_horizontal.png" class="m-b" width="100%" alt="logo">-->
              <!--</v-flex>-->
              <!--<v-flex xs2 sm2 md2 lg2>-->
                <!--<img style="padding: 5%" src="@/assets/Both/Logos/Ol%20Pejeta%20Ranching/OP_Ranching%20Logo.png" class="m-b" width="100%" alt="logo">-->
              <!--</v-flex>-->
              <!--<v-flex xs2 sm2 md2 lg2>-->
                <!--<img style="padding: 5%" src="@/assets/Both/Logos/Safari%20Diner/Safari_Diner_logo.png" class="m-b" width="100%" alt="logo">-->
              <!--</v-flex>-->
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
export default {
  name: 'PasswordReset',
  data () {
    return {
      login: {
        password: '',
        new_password: '',
        reset_id: this.$route.params.reset_id
      }
    }
  },
  methods: {
    doReset () {
      if (this.login.password === this.login.new_password) {
        this.$store.dispatch('loading_true')
        this.$store.dispatch('reset_password', this.login)
      } else {
        alert('Make sure the password and confirm password are same.')
      }
    }
  }
}
</script>

<style scoped>

</style>
